module.exports = __webpack_public_path__ + "assets/img/dzh-9.da51884d.jpg";